import React from 'react';
import Reflux from 'reflux';
import FullscreenModal from 'shared/components/misc/fullscreenModal.jsx';
import UIRegions from 'shared/constants/UIRegions';
import PDFExport from 'main/components/show/cuesheet.printable/pdfExportForm/form.jsx';

/**
 * Export PDF Modal
 *
 */
export default React.createClass({
  mixins: [Reflux.ListenerMixin],

  displayName: 'ExportPDFModalV3',

  render() {
    return (
      <FullscreenModal
        headerClassName="pdf-export-modal-header"
        name={UIRegions.ExportPDFV3Form}
        title="Export to PDF"
      >
        <PDFExport />
      </FullscreenModal>
    );
  },
});
